<template>
    <v-card class="zoezi-bottom-sheet" tile elevation="0">
        <v-card-title class="headline align-start flex-column pa-2 primary primarytext--text">
            <div class="font-weight-bold fill-width">
                <span v-if="!almostdone">
                    {{$translate(!showBuySteps ? 'Log in and book' : 'Purchase training card and reserve')}}
                </span>
                <v-btn icon @click="$emit('close')" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
            </div>
        </v-card-title>
        
        <v-card-text :class="{'px-2': !this.almostdone && $vuetify.breakpoint.mobile, 'px-0': this.almostdone, 'pb-0': this.almostdone }" class="z-no-x-scroll overflow-y-auto">
            <identification v-if="!showBuySteps" :title="$translate('Who are you who book?')" :sub-title="$translate('Complete your payment by identifying yourself')" />
            <checkout
                v-else
                ref="checkout"
                class="overflow-y-auto"
                :items="checkoutItems"
                :expand-first-item="true"
                :show-summary="true"
                :show-back-link="false"
                :show-payment-button="false"
                :force-done="almostdone"
                @almostdone="almostdone = true; doneCheckout()"
                @done="doneCheckout(); $emit('close')"
                @loading="checkoutLoading = $event; loadingCheckout($event)"
                @changeItemUsers="changeItemUsers"
                @readyToPay="readyToPay = $event"
                @cost="cost = $event"
                content-target="checkoutcontent"
                count-read-only
                :show-sum="!!selectedCardId"
                :identification-title="$translate('Who are you who book?')"
                :identification-sub-title="$translate('Complete your payment by identifying yourself')"
                :dialog="true"
                :new-style-done-dialog="true"
            >
                <template #content>
                    <stepper-content v-model="currentStep" :steps="steps">
                        <template #cards>
                            <v-expansion-panels v-model="expandedPanel" accordion flat>
                                <v-expansion-panel>
                                    <expansion-panel-header
                                        icon="mdi-tag-plus-outline"
                                        :title="$translate('For this activity, a membership card is required')"
                                        :subtitle="$translate('Choose from the cards below')"
                                    />
                                    <v-expansion-panel-content class="z-dense">                            
                                        <simple-product-list :products="cards" @buy="selectedCardId = $event.id; currentStep++" :buy-button-text="$translate('Choose')"  />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </template>
                        <template #membership>
                            <membership-checkout :items="checkoutItems" @buy="onBuyMembership" />
                        </template>
                        <template #checkout>
                            <portal-target name="checkoutcontent" />
                        </template>
                    </stepper-content>
                </template>
                <template #workoutbooking>
                    <div class="mt-2">
                        <v-row no-gutters>
                            <v-col cols=6>
                                <div>
                                    <v-icon color="primary">mdi-calendar</v-icon> {{Date.formatFullShortRelative(workout.startTime)}}
                                </div>
                            </v-col>
                            <v-col cols=6>
                                <div>
                                    <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>{{workout.startTime.hhmm()}}
                                </div>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <v-col cols=6>
                                <div v-if="workout.location">
                                    <v-icon small color="primary" class="mr-1">mdi-map-marker</v-icon>{{workout.location.name}}
                                </div>
                            </v-col>
                            <v-col cols=6>
                                <div v-if="workout.staffs.length">
                                    <v-icon small color="primary" class="mr-1">mdi-account-outline</v-icon>{{workout.staffs.map(s => s.name).join(', ')}}
                                </div>
                            </v-col>
                        </v-row>

                        <div v-if="bookingConditions.length">
                            <div class="my-2"><v-divider /></div>
                            <div class="font-weight-bold">{{$translate('Note! This activity is only open to:')}}</div>
                            <ul>
                                <li v-for="cond in bookingConditions" :key="cond" v-text="cond" />
                            </ul>
                        </div>
                    </div>
                </template>
            </checkout>
        </v-card-text>

        <v-card-actions v-if="showBuySteps && !almostdone">
            <stepper v-model="currentStep" :steps="steps" @cancel="$emit('close')" ref="stepper" :show="!almostdone" :disabled="checkoutLoading" />
        </v-card-actions>
    </v-card>
</template>

<script>
import {formatPrice} from '../util.js'
import Stepper from '../views/Stepper.vue'
import StepperContent from '../views/StepperContent.vue'
import Checkout from '../views/Checkout.vue'
import SimpleProductList from '../views/SimpleProductList.vue'
import Identification from '../views/Identification.vue'
import ExpansionPanelHeader from '../views/ExpansionPanelHeader.vue'
import MembershipCheckout from './MembershipCheckout.vue'
export default {
    name: 'zoezi-workoutbookingsteps',

    components: {
        Stepper,
        StepperContent,
        Checkout,
        SimpleProductList,
        Identification,
        ExpansionPanelHeader,
        MembershipCheckout
    },

    props: ['workout', 'login', 'trial', 'queue', 'user_id'],

    watch: {
        workout: {
            immediate: true,
            handler() {
                this.unreserve();
                if (this.workout) {
                    if (!this.queue) {
                        this.reserve();
                    }
                    this.waitingForCards = this.queue;
                    this.showBuySteps = !this.login;
                    if (this.cards.length == 1) {
                        this.selectedCardId = this.cards[0].id;
                        this.currentStep = 1;
                    }

                    if (this.workout?.workoutType?.booking_interests) {
                        this.$store.dispatch('loadInterests')
                    }
                }
            }
        },
        '$store.state.user': {
            immediate: true,
            handler(user) {
                if (user && !this.buyingFor) {
                    this.buyingFor = [this.user_id || user.id];
                }
            }
        },
        '$store.state.isLoggedIn'(loggedIn) {
            if (this.login && loggedIn) {
                if (!this.buyingFor) {
                    this.buyingFor = [this.$store.state.user.id];
                }
                if (this.workout.isBooked()) {
                    this.$emit('done');
                } else {
                    if (this.$store.state.user.canBookFor.length == 1) {
                        this.waitingForCards = true;
                    } else {
                        this.$emit('canBookForSeveral');
                    }
                }
            }
        },
        '$store.state.cards'() {
            if (this.waitingForCards) {
                if (this.workout.hasValidTrainingCard()) {
                    this.$emit('book')
                    this.waitingForCards = false;
                    if (!this.showBuySteps) {
                        this.$emit('done')
                    }
                } else {
                    this.showBuySteps = true;
                }
            }
        }
    },

    computed: {
        checkoutItems() {
            if (!this.selectedCardId) {
                return [
                    {product_id: null, workout_bookings: [{reservation: this.reservation_id, workout_id: this.workout.id, workout: this.workout}]}
                ];
            }

            let memberships = [];
            if (this.membership) {
                memberships = [
                    {
                        count: 1,
                        users: this.buyingFor,
                        product_id: this.membership.id,
                        product: this.membership
                    }
                ]
            }
            let product = this.cards.find(x => x.id == this.selectedCardId);

            if (this.queue) {
                return [{product_id: this.selectedCardId, product, users: this.buyingFor}].concat(memberships);
            } else {
                let onetime = this.cards.find(x => x.id == this.selectedCardId)?.onetime;
                if (onetime) {
                    return [
                        {workout_id: this.workout.id, reservation: this.reservation_id, workout: this.workout, users: this.buyingFor, price: this.workout.workoutType.price }
                    ].concat(memberships);
                }

                return [
                    {product_id: this.selectedCardId,  product, users: this.buyingFor, workout_bookings: [{reservation: this.reservation_id, workout_id: this.workout.id, workout: this.workout}]}
                ].concat(memberships);
            }
        },
        cards() {
            return this.trial ? this.workout.getTrialCards() : this.workout.getBuyableCards();
        },
        basket() {
            let basket = {};
            this.cards.forEach(card => {
                basket[card.id] = this.selectedCardId == card.id ? 1 : 0
            })
            return basket;
        },
        steps() {
            let nextTitle = this.cost > 0 ? this.$translate('Pay {0} and book').format(formatPrice(this.cost)) : this.$translate('Confirm purchase and book');
            if (!this.selectedCardId || isNaN(this.cost)) {
                if (this.selectedCardId && !this.$store.state.user) {
                    nextTitle = this.$translate('Identify yourself');
                } else {
                    nextTitle = this.$translate('Choose training card');
                }
            }
            let payComplete = this.$store.state.isLoggedIn && this.readyToPay && this.selectedCardId && !isNaN(this.cost);
            let showMemberships = this.$booking.isMembershipRequired(this.checkoutItems);
            let mcomplete = !this.$booking.isMembershipStillRequired(this.checkoutItems);
            const pay = this.$translate('Pay');

            return [
                {title: this.$translate('Training card'), id: 'cards', complete: !!this.selectedCardId, nextTitle},
                showMemberships && {title: this.$translate('Membership'), id: 'membership', complete: mcomplete, nextTitle: this.$translate(mcomplete ? 'Continue' : 'Choose membership')},
                {title: pay, id: 'checkout', nextTitle, nextColor: '#7bbd1b', nextDark: true, nextClicked: this.pay, nextLoading: this.checkoutLoading, complete: payComplete },
                {title: this.$translate('Done'), id: 'done'}
            ].filter(x => x);
        },
        bookingConditions() {
            let conditions = [];

            let adults;
            if (this.workout.workoutType.booking_age) {
                adults = this.workout.workoutType.booking_age.from >= 18;
            }

            let gender;
            if (this.workout.workoutType.booking_gender == 'male') {
                gender = adults ? 'Men' : 'Boys';
            } else if (this.workout.workoutType.booking_gender == 'female') {
                gender = adults ? 'Women' : 'Girls';
            }

            if (this.workout.workoutType.booking_age) {
                let persons = this.$translate(gender || 'Persons');
                conditions.push(`${persons} ${this.workout.workoutType.booking_age.from} - ${this.workout.workoutType.booking_age.to} ${this.$translate('years')}`)
            } else if (gender) {
                conditions.push(gender);
            }
            
            if (this.workout.workoutType.booking_interests) {
                if (!this.$store.state.interests) {
                    conditions.push(this.$translate('Booking requires some interests'))
                } else {
                    let interests = this.$store.state.interests;
                    conditions.push(this.workout.workoutType.booking_interests.map(i => interests.find(io => io.id == i).name).sort((a,b) => a.localeCompare(b)).join(', ') )
                }
            }

            if (this.workout.workoutType.booking_groups) {
                conditions.push(this.$translate('Booking requires certain group membership'))
            }

            return conditions;
        }
    },

    data: () => ({
        reservation_id : null,
        checkoutReservation: null,
        almostdone: false,
        checkoutLoading: false,
        readyToPay: false,
        currentStep: 0,
        selectedCardId: null,
        cost: NaN,
        showBuySteps: false,
        waitingForCards: false,
        expandedPanel: 0,
        buyingFor: null,
        membership: null
    }),

    methods: {
        reserve() {
            this.$api.post('/api/resource/reservation/add', {workout_id: this.workout.id, user_id: this.user_id}).then(response => {
                if (response.ok) {
                    response.json().then(x => {
                        this.reservation_id = x.key;
                        window.addEventListener('beforeunload', this.unreserve);
                    })
                } else {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Error during reservation'), text: this.$translate('Something went wrong when the booking was to be reserved')});
                    this.$emit('error');
                }
            })
        },
        unreserve() {
            if (this.reservation_id) {
                this.$api.post('/api/resource/reservation/cancel', {key: this.reservation_id});
                this.reservation_id = null;
                window.removeEventListener('beforeunload', this.unreserve);
            }
        },
        doneCheckout() {
            this.checkoutReservation = null;
            if (this.reservation_id) this.unreserve();
        },
        loadingCheckout(loading) {
            if (loading) {
                if (!this.reservation_id) return;
                this.checkoutReservation = this.reservation_id;
                this.reservation_id = null;
                window.removeEventListener('beforeunload', this.unreserve);
            } else if (this.checkoutReservation) {
                this.reservation_id = this.checkoutReservation;
                window.addEventListener('beforeunload', this.unreserve);
            }
        },
        pay() {
          this.$refs.checkout.completePurchase();
        },
        changeItemUsers(item, users) {
            this.buyingFor = users;
        },
        onBuyMembership(product) {
            this.membership = product;
            this.currentStep++;
        }
    },
    destroyed() {
        this.unreserve();
    }
  }
</script>
